import { BulkActionsBar } from '@/components/BulkActionsBar';
import { useSelectedVideos } from '@/state/video-library/videoLibrary';
import { Actions } from './Actions';

export const VideoBulkActionsBar = () => {
    const { selected, reset } = useSelectedVideos();

    return (
        <BulkActionsBar reset={reset} selectedElementsCount={selected.size}>
            <Actions />
        </BulkActionsBar>
    );
};
